import * as React from 'react';
import { Modal } from '@teamsnap/teamsnap-ui';
import { Icon, LabelButton } from '@teamsnap/snap-ui';

type Props = {
  closeFn: () => void;
  closeWarning: () => void;
  isOpen: boolean;
};

const ChangesMadeWarningModal: React.FC<Props> = ({ closeFn, closeWarning, isOpen }) => (
  <Modal
    heading=""
    show={isOpen}
    testId="ChangesMadeWarningModal--modal"
    style={{ paddingBottom: 20, paddingLeft: 20, paddingRight: 20, borderRadius: 4, minWidth: 375, maxWidth: 375 }}
  >
    <div>
      <div className="sui-flex sui-items-center">
        <Icon name="report" size="l" filled className="sui-text-red-40" />
        <h3 className="sui-ml-2">New form not created.</h3>
      </div>

      <div className="sui-mt-3">
        <p className="sui-body">New registration form has not been created yet. Your work will be lost.</p>
      </div>

      <div className="sui-flex sui-justify-end sui-mt-5">
        <LabelButton
          labelText="Cancel"
          variantType="tertiary"
          onClick={closeWarning}
          data-testid="ChangesMadeWarningModal--cancel"
          className="sui-mr-1 sui-cursor-pointer"
        />

        <LabelButton
          labelText="Close anyway"
          variantType="primary"
          onClick={closeFn}
          sentiment="negative"
          data-testid="ChangesMadeWarningModal--continue"
          className="sui-cursor-pointer"
        />
      </div>
    </div>
  </Modal>
);

export default ChangesMadeWarningModal;
